import React from "react";
import { Button, Modal, Form } from "react-bootstrap";

export default function SuiviClientModal({
  handleClose,
  show,
  handleSubmitCustomerLog,
  customerlog,
  handleCustomerlogChange,
  action,
}) {
  const [formData] = React.useState({
    content: customerlog.content || "",
    log_date: customerlog.log_date || "",
  });
  const [newFormData, setNewFormData] = React.useState({ ...formData });
  const handleInputChange = (e) => {
    //console.log(formData);
    //console.log(newFormData);
    setNewFormData({
      ...newFormData,
      [e.target.name]: e.target.value,
    });
  };
  const handleModalHide = () => {
    var windowConfirm = false;
    if (JSON.stringify(formData) !== JSON.stringify(newFormData)) {
      windowConfirm = true;
    }
    if (windowConfirm) {
      if (
        window.confirm(
          "Vous avez effectué des changements, êtes vous sûr de vouloir quitter sans valider ?"
        )
      ) {
        handleClose();
      }
    } else {
      handleClose();
    }
  };

  return (
    <>
      <Modal
        show={show}
        size="lg"
        onHide={() => {
          handleModalHide();
        }}
        centered
        fullscreen={""}
        className="w-100"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={(e) => handleSubmitCustomerLog(e, customerlog)}>
          <Modal.Body>
            <div className="row">
              <div className="col mb-3">
                <Form.Group className="mb-3" controlId="new-operation">
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="date"
                    className="mb-3"
                    autoFocus
                    required
                    value={customerlog.log_date}
                    name="log_date"
                    onChange={(e) => {
                      handleInputChange(e);
                      handleCustomerlogChange(e, "log_date");
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-md border-start">
                <Form.Group className="mb-3" controlId="add-customercare">
                  <Form.Label>Contenu</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={10}
                    value={customerlog.content}
                    name="content"
                    onChange={(e) => {
                      handleInputChange(e);
                      handleCustomerlogChange(e, "content");
                    }}
                    required
                  />
                </Form.Group>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="is-bottom-right">
            <Button variant="secondary" onClick={handleClose}>
              Annuler
            </Button>
            <Button variant="success" type="submit">
              valider
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}
